import { Typography } from "antd";
import React from "react";
import { HistoryItemStatus } from "./HistoryItemStatus.tsx";

interface Props {
  actual_status?: string | null;
  prev_status?: string | null;
  prevColor: string;
  prevIcon: React.ReactNode;
  prevText: string;
  actualColor: string;
  actualIcon: React.ReactNode;
  actualText: string;
}

export const HistoryFolderStatus: React.FC<Props> = ({
  actual_status,
  prev_status,
  prevColor,
  prevIcon,
  prevText,
  actualColor,
  actualIcon,
  actualText,
}) => {
  return (
    actual_status !== prev_status && (
      <div className="flex flex-wrap items-center">
        <Typography.Text className="font-medium">
          Estatus:&nbsp;
        </Typography.Text>
        {prev_status && (
          <div className="flex items-center">
            <HistoryItemStatus
              color={prevColor}
              icon={prevIcon}
              text={prevText}
            />
            <span className="text-gray-500">→</span>
          </div>
        )}
        <HistoryItemStatus
          color={actualColor}
          icon={actualIcon}
          text={actualText}
        />
      </div>
    )
  );
};
